import { commentaryMessageTypes } from '@/constants/common'
import { focusIds as globalFocusIds } from '@/constants/focus'
import { icons } from '@/constants/icons'

export const MAX_MATCHES_ON_PAGE = 6
export const standingsRowHeight = 50
export const matchRowHeight = 88
export const rowMarginBottom = 7
export const maxMatchesTableHeight =
  MAX_MATCHES_ON_PAGE * matchRowHeight +
  (MAX_MATCHES_ON_PAGE - 1) * rowMarginBottom
export const focusIds = {
  standingsGroupsWrapper: 'groups-standings-wrapper',
  standingsGroupsItem: 'groups-standings-item',
  standingsLeagueContainer: 'standings-league-container',
  matchesTable: 'matches-table',
  matchesContainer: 'matches-container',
  match: globalFocusIds.DATA_WIDGET + 'match',
  matchCommentary: globalFocusIds.DATA_WIDGET + 'commentary',
  pagePopup: globalFocusIds.PAGE_POPUP,
}
export const STANDINGS_GROUPS_SCROLL_OFFSET = 0
export const MATCHES_SCROLL_OPTIONS = {
  offset: -285,
  containerId: focusIds.matchesTable,
  height: maxMatchesTableHeight,
  smooth: true,
  duration: 0,
}
export const STANDINGS_SCROLL_OPTIONS = {
  offset: -250,
  containerId: focusIds.standingsLeagueContainer,
  height: 650,
  smooth: true,
  duration: 0,
}
export const commentaryScrollOffset = 110
export const MESSAGE_ICONS = {
  [commentaryMessageTypes.GOAL]: icons.commentary.goal,
  [commentaryMessageTypes.OWN_GOAL]: icons.commentary.goal,
  [commentaryMessageTypes.PENALTY_GOAL]: icons.commentary.goal,
  [commentaryMessageTypes.SUBSTITUTION]: icons.commentary.sync,
  [commentaryMessageTypes.RED_CARD]: icons.commentary.redCard,
  [commentaryMessageTypes.YELLOW_CARD]: icons.commentary.yellowCard,
  [commentaryMessageTypes.SECOND_YELLOW_CARD]: icons.commentary.redCard,
}
